import clsx from 'clsx';

interface Tab {
  id: string;
  label: string;
  badge?: number;
}

interface TabNavProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}

export function TabNav({ tabs, activeTab, onChange, className }: TabNavProps) {
  return (
    <div className={clsx('flex gap-1 overflow-x-auto border-b border-gray-200', className)}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onChange(tab.id)}
          className={clsx(
            'relative shrink-0 px-4 py-3 text-sm font-medium transition-colors',
            activeTab === tab.id
              ? 'border-b-2 border-brand-500 text-brand-600'
              : 'text-gray-600 hover:text-gray-900',
          )}
        >
          {tab.label}
          {tab.badge !== undefined && tab.badge > 0 && (
            <span className="ml-1.5 rounded-full bg-brand-500 px-1.5 py-0.5 text-xs text-white">
              {tab.badge}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
